import React from 'react';
import classNames from 'classnames';
import { Icons } from '../../../components/base/BootstrapComponents';

export default function HelperTooltip() {
  return (
    <div className="parking-meter-helper-tooltip">
      <div className="pmh-block">
        <div className="pmh-title">Легенда</div>
        <div className="pmh-table">
          <div className="pmh-column pmh-left-column">
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon good-state" /></div>
              <div className="pmh-text">Доступен</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon warning-state" /></div>
              <div className="pmh-text">Временно недоступен</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon error-state" /></div>
              <div className="pmh-text">Недоступен</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="where-to-vote" className="pmh-icon where-to-vote" /></div>
              <div className="pmh-text">Переход на карту</div>
            </div>
          </div>
          <div className="pmh-column pmh-right-column">
            <div className="pmh-row">
              <div className="pmh-icon-wrapper">
                <div className={classNames('processing-formatter', { processing: true })}>
                  <Icons customIcon icon="processing" className="pmh-icon processing-icons" />
                  <div className="processing-text ">on</div>
                </div>
              </div>
              <div className="pmh-text">Распознование включено</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper">
                <div className={classNames('processing-formatter', { processing: false })}>
                  <Icons customIcon icon="processing" className="pmh-icon processing-icons" />
                  <div className="processing-text ">off</div>
                </div>
              </div>
              <div className="pmh-text">Распознование выключено</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper">
                <div className={classNames('processing-formatter', { unknown: true })}>
                  <Icons customIcon icon="processing-unknown" className={classNames('processing-icons', { unknown: true })} />
                </div>
              </div>
              <div className="pmh-text">Распознование неизвестно</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
